import { createAction, props } from "@ngrx/store";

export const OpenPage = createAction('[System] Open Page', props<{ url: string; target?: string }>());
export const Redirect = createAction('[System] Redirect', props<{ url: string }>());
export const RedirectToCourtesyPage = createAction('[System] Redirect to courtesy page');
export const RedirectToHomePage = createAction('[System] Redirect to home page');
